// import styled from 'styled-components';
// import { darken } from 'polished';

// export const Container = styled.div`
//   display: flex;
//   justify-content: flex-end;

//   & > button {
//     border: 0;
//     padding: 0 2px;
//     background: none;
//     color: #cbd0d8;
//     transition: color 1s;

//     & + button {
//       margin-left: 10px;
//     }
//   }

//   #btn-line-view {
//     :hover {
//       color: #538061;
//     }
//   }

//   #btn-line-download,
//   #btn-line-edit,
//   #btn-line-copy {
//     :hover {
//       color: #5485f7;
//     }
//   }

//   #btn-line-user-password {
//     :hover {
//       color: #e6de2a;
//     }
//   }

//   #btn-line-remove {
//     :hover {
//       color: #de3b3b;
//     }
//   }

//   #btn-line-manager,
//   #btn-line-generate-token {
//     :hover {
//       color: #538061;
//     }
//   }

//   #btn-line-generate-qrcode {
//     :hover {
//       color: #374151;
//     }
//   }

//   #btn-action {
//     /* color: '#ff6d3c' */

//     :hover {
//       color: ${darken(0.1, '#ff6d3c')};
//     }
//   }

//   #btn-whatsapp {
//     /* light green  */
//     /* background-color: #5ffc7b; */
//     /* background-color: #25d366; */
//     /* background-color: #59ce72; */
//     /* dark green */
//     /* background-color: #28d146; */
//     color: #28d146;
//     /* color: #ffffff; */
//     /* padding: 8px; */
//     border-radius: 5px;
//   }
// `;

// export const Wrapper = styled.div`
//   z-index: 99;
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   position: relative;

//   & > ul {
//     position: absolute;
//     right: 0;
//     top: 30px;
//     background: #fff;
//     font-size: 14px;
//     border: 1px solid #dbe1e9;
//     border-radius: 4px;
//     box-shadow: 0px 0px 2px #00000026;
//     min-width: 180px;

//     & > li {
//       display: flex;
//       color: #444;
//       align-items: center;
//       margin: 0 10px;
//       padding: 10px 5px;
//       transition: background 0.3s;

//       &:not(:last-child) {
//         border-bottom: 1px solid #dbe1e9;
//       }

//       svg {
//         margin-right: 5px;
//       }

//       button {
//         flex: 1;
//         display: flex;
//         align-items: center;
//         text-align: left;
//         border: 0;
//         padding: 0 2px;
//         background: none;
//         color: #444;

//         &#act-exit {
//           color: #dd0312;
//         }
//       }
//     }
//   }
// `;

// export const NotificationWrapper = styled.div`
//   position: relative;
// `;

// export const NotificationBadge = styled.span`
//   position: absolute;
//   top: -2px;
//   right: -2px;
//   width: 12px;
//   height: 12px;
//   border: 1px solid #f2f5fc;
//   border-radius: 50%;
//   background: red;
//   color: #ff474d;
// `;

import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --blue: #1789dd   --muted: #cbd0d8
   --border: rgba(216, 224, 235, 0.9)
   Cores semânticas dos botões de linha preservadas (apenas mais legíveis).
=========================================================== */

const dropIn = keyframes`
  from { opacity: 0; transform: translateY(-8px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    width: 34px;
    border: 0;
    border-radius: 10px;
    background: none;
    color: #cbd0d8;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

    & + button {
      margin-left: 6px;
    }

    &:hover {
      transform: translateY(-1px);
    }
  }

  #btn-line-view {
    :hover {
      color: #538061;
      background: rgba(83, 128, 97, 0.12);
    }
  }

  #btn-line-download,
  #btn-line-edit,
  #btn-line-copy {
    :hover {
      color: #1789dd;
      background: rgba(23, 137, 221, 0.1);
    }
  }

  #btn-line-user-password {
    :hover {
      color: #d6a017;
      background: rgba(214, 167, 23, 0.14);
    }
  }

  #btn-line-remove {
    :hover {
      color: #de3b3b;
      background: rgba(222, 59, 59, 0.12);
    }
  }

  #btn-line-manager,
  #btn-line-generate-token {
    :hover {
      color: #538061;
      background: rgba(83, 128, 97, 0.12);
    }
  }

  #btn-line-generate-qrcode {
    :hover {
      color: #374151;
      background: rgba(55, 65, 81, 0.1);
    }
  }

  #btn-action {
    :hover {
      color: ${darken(0.1, '#ff6d3c')};
      background: rgba(255, 109, 60, 0.12);
    }
  }

  #btn-whatsapp {
    /* color: #28d146; */
    color: #3a4d66;
    border-radius: 10px;
  }
`;

export const Wrapper = styled.div`
  z-index: 99;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  position: relative;

  & > ul {
    position: absolute;
    right: 0;
    top: ${(props) => (props.topContainer ? '-155px' : '34px')};
    min-width: 200px;
    padding: 8px;

    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 12px;
    box-shadow: 0 18px 44px rgba(23, 38, 59, 0.16),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    backdrop-filter: blur(14px);
    font-size: 14px;
    animation: ${dropIn} 0.18s cubic-bezier(0.22, 1, 0.36, 1) both;

    & > li {
      display: flex;
      align-items: center;
      color: #3a4d66;
      border-radius: 9px;
      padding: 10px 12px;
      transition: background 0.18s ease, color 0.18s ease;

      svg {
        margin-right: 8px;
        color: #ff6d3c;
      }

      &:hover {
        background: rgba(255, 109, 60, 0.1);
        color: #17263b;
      }

      button {
        flex: 1;
        display: flex;
        align-items: center;
        text-align: left;
        border: 0;
        padding: 0;
        background: none;
        color: inherit;
        font-weight: 600;
        cursor: pointer;

        &#act-exit {
          color: #dd0312;
        }
      }
    }
  }
`;

export const NotificationWrapper = styled.div`
  position: relative;
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 0 2px #fff, 0 2px 6px rgba(239, 68, 68, 0.5);
`;
